import { ActionCreatorProps, createAction, props } from '@ngrx/store'
import { UserData, CustomFieldValue } from './manage-subscription.state'

export enum ManageSubscriptionActions {
  TRY_LOAD_DATA = '[MANAGE SUBSCRIPTION] Load user data',
  SUCCESS_LOAD_DATA = '[MANAGE SUBSCRIPTION] Success on load data',
  ERROR_LOAD_DATA = '[MANAGE SUBSCRIPTION] Error on load data',
  SUCCESS_LOAD_CUSTOM_FIELDS = '[MANAGE SUBSCRIPTION] Success on load custom fields',
  ERROR_LOAD_CUSTOM_FIELDS = '[MANAGE SUBSCRIPTION] Error on load custom fields',
  TOGGLE_OPTION = '[MANAGE SUBSCRIPTION] Change option status',
  TOGGLE_ABSENDER_SELECTION = '[MANAGE SUBSCRIPTION] Change absender status',
  TOGGLE_THEMEN_SELECTION = '[MANAGE SUBSCRIPTION] Change themen status',
  TOGGLE_USER_ORIGIN = '[MANAGE SUBSCRIPTION] change origin custom field',
  UNMARK_ALL = '[MANAGE SUBSCRIPTION] Unmark all subscriptions',
  UNMARK_USER_DOI = '[MANAGE SUBSCRIPTION] Unmark doi subscriptions',
  TRY_SAVE_USER_PREF = '[MANAGE SUBSCRIPTION] Try save user pref',
  SAVE_USER_PREF_SUCCESS = '[MANAGE SUBSCRIPTION] Save user pref success',
  SAVE_USER_PREF_ERROR = '[MANAGE SUBSCRIPTION] Save user pref error',
  UNSUBSCRIBE = '[MANAGE SUBSCRIPTION] Unsubscribe and save',
}

function propsFactory<T>(): ActionCreatorProps<{ payload: T }> {
  return props<{ payload: T }>()
}

export const manageSubscriptionActions = {
  tryLoadData: createAction(ManageSubscriptionActions.TRY_LOAD_DATA, propsFactory<{ userId: string }>()),
  successLoadData: createAction(ManageSubscriptionActions.SUCCESS_LOAD_DATA, propsFactory<UserData | undefined>()),
  errorLoadData: createAction(ManageSubscriptionActions.ERROR_LOAD_DATA, propsFactory<{ error: string }>()),
  successLoadCustomFields: createAction(
    ManageSubscriptionActions.SUCCESS_LOAD_CUSTOM_FIELDS,
    propsFactory<CustomFieldValue[]>(),
  ),
  errorLoadCustomFields: createAction(
    ManageSubscriptionActions.ERROR_LOAD_CUSTOM_FIELDS,
    propsFactory<{ error: string }>(),
  ),
  toggleOption: createAction(ManageSubscriptionActions.TOGGLE_OPTION, propsFactory<{ index: number }>()),
  toggleAbsenderSelection: createAction(
    ManageSubscriptionActions.TOGGLE_ABSENDER_SELECTION,
    propsFactory<{ aId: string }>(),
  ),
  toggleThemenSelection: createAction(
    ManageSubscriptionActions.TOGGLE_THEMEN_SELECTION,
    propsFactory<{ aId: string; tId: string }>(),
  ),
  toggleUserOrigin: createAction(
    ManageSubscriptionActions.TOGGLE_USER_ORIGIN,
    propsFactory<{ customFieldId: string }>(),
  ),
  unmarkAll: createAction(ManageSubscriptionActions.UNMARK_ALL, propsFactory()),
  unmarkUserDoi: createAction(ManageSubscriptionActions.UNMARK_USER_DOI, propsFactory()),
  trySaveUserPref: createAction(
    ManageSubscriptionActions.TRY_SAVE_USER_PREF,
    propsFactory<{ unsubscribeCover: boolean }>(),
  ),
  saveUserPrefSuccess: createAction(ManageSubscriptionActions.SAVE_USER_PREF_SUCCESS, propsFactory()),
  saveUserPrefError: createAction(ManageSubscriptionActions.SAVE_USER_PREF_ERROR, propsFactory<{ error: string }>()),
  unsubscribe: createAction(ManageSubscriptionActions.UNSUBSCRIBE, propsFactory()),
}
